<template>
  <div class="imageUploader">
    <!-- <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div>
    <div class="brand-image-item"><BrandImageUploader /></div> -->
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
    <div class="image-item"><ImageUploader /></div>
  </div>
</template>

<script>
import ImageUploader from "../../components/ImageUploader.vue";
import BrandImageUploader from "../../components/BrandImageUploader.vue";

export default {
  components: {
    ImageUploader,
    BrandImageUploader,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .image-item {
    width: 450px;
    height: 1000px;
    display: inline-block;
    margin: 20px;
    /* background-color: white; */
  }

  .brand-image-item {
    width: 450px;
    height: 600px;
    display: inline-block;
    margin: 20px;
    /* background-color: white; */
  }
}
</style>
